import {buildArtifactsApi} from '../../../../../services/buildArtifacts'
import type {BuildId} from '../../../../../types'

type Props = {
  buildId: BuildId
  className?: string
}

function BuildArtifactsSize({buildId, className}: Props) {
  const {size} = buildArtifactsApi.endpoints.getArtifactsSize.useQuery(
    {buildId, showAll: false},
    {selectFromResult: ({data}) => ({size: data?.size})},
  )
  return <span className={className}>{size}</span>
}

export default BuildArtifactsSize
